import {type BaseError} from '../../../../../../../shared/errors/BaseError.ts'
import {UIMMatchmakingController} from './matchmaking_selection/UIMMatchmakingController.ts'
import {ViewPopup} from '../../../../../../shared/scripts/ui_popup/ViewPopup.ts'

export class UIMHomepageController {
    private errorPopup: ViewPopup

    readonly matchmakingController: UIMMatchmakingController

    constructor() {
        this.matchmakingController = new UIMMatchmakingController()
    }

    onHomepageHide() {
        this.matchmakingController.removeSearchingScreen()
    }

    showMatchmakingError(error: BaseError) {
        this.matchmakingController.stopSearching()
        this.errorPopup?.removePopup()
        this.errorPopup = new ViewPopup({key: 'strings:popups.errors.matchmakingError.rankedMode'},
            error.description,
            () => undefined,
            () => undefined,
            true, {
                showXButton: false,
                showXonHeader: true,
            })
        this.errorPopup.show()
    }
}
